// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DNHeI","content":"styles_content__1Lxyc","tableWrap":"styles_tableWrap__cgeEo"};